export var CreditScorePurpose;
(function (CreditScorePurpose) {
    CreditScorePurpose["Refinance"] = "REFINANCE";
    CreditScorePurpose["NewPurchase"] = "NEW_PURCHASE";
    CreditScorePurpose["NewPurchaseLater"] = "NEW_PURCHASE_LATER";
    CreditScorePurpose["NmpPersonalCarLoan"] = "NMP_PERSONAL_CAR_LOAN";
    CreditScorePurpose["Curious"] = "CURIOUS";
    CreditScorePurpose["CreditCard"] = "CREDIT_CARD";
    CreditScorePurpose["Other"] = "OTHER";
})(CreditScorePurpose || (CreditScorePurpose = {}));
//# sourceMappingURL=index.js.map